<div class="container">
  <div class="row" id="main-content">
    <h1 class="text-center" tabindex="0">
      {{ 'COMMON.SESSION_TIMEOUT' | translate }}
    </h1>
  </div>
  <div class="row">
    <p class="text-center" tabindex="0">
      {{ 'COMMON.RESTART_APPLICATION' | translate }}
    </p>
  </div>
  <div class="row">
    <button class="govuk-button govuk-button--inverse restart-btn" (click)="restart()">
      {{ 'COMMON.RESTART' | translate }}
    </button>
  </div>
</div>
